import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Navigation.css';

const Navigation: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="nav">
      <div className="nav-container">
        <div className="nav-brand">
          <h2 className="nav-logo">DEEP Q DIGITAL</h2>
        </div>

        <div className="nav-links">
          <NavLink 
            to="/dashboard" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Dashboard
          </NavLink>
          <NavLink 
            to="/letters" 
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            Investor Letters
          </NavLink>
        </div>

        <div className="nav-user">
          <span className="nav-user-info">
            {user?.isAdmin ? 'Admin' : user?.investorId}
          </span>
          <button onClick={handleLogout} className="nav-logout">
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;